export default class LicencaIKAcesso {
    constructor() {
        this.id =  null;
        this.descricao =  null;
        this.quantidadeMeses =  null;
        this.quantidadeEquipamentos = null;
        this.sistemaAcesso =  false;
        this.sistemaEscola =  false;
        this.sistemaRefeicao =  false; 
        this.estenderValidade =  false;       
        this.atualizarPacote = false;
        this.atualizada = false;
    }
}